const PACKAGES_CONSTANTS = {
    GET_PACKAGE_DETAILS: 'v1/package'
};

export default PACKAGES_CONSTANTS;
